// app/timeSheet/timeSheet.js

(function () {
    'use strict';

    var controllerId = 'timeSheet';
    angular.module('app').controller(controllerId, ['$rootScope', '$routeParams', 'datacontext', 'common', 'sectionMenu', '_', 'bootstrap.dialog', '$uibModal', '$filter', '$translate', timeSheetFn]);

    function timeSheetFn($rootScope, $routeParams, datacontext, common, sectionMenu, _, bDialog, $uibModal, $filter, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'TimeSheet';
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.timeSheet = {};
        vm.list = {};
        vm.list.commesse = [];
        vm.list.giustificativi = [];
        vm.giorni = [];
        vm.date = [];                                           //Questo contiene le date da inserire nella tabella ore
        vm.colFestivo = [];
        vm.colTitle = [];
        vm.bSelDipendente = false;
        vm.bConvalida = false;
        vm.bLock = false;

        vm.personale = $rootScope.isAuthorized('PERSONALE');

        if ($rootScope.isAuthorized('PERSONALE') || $rootScope.isAuthorized('CAPOSEZIONE')) {
            vm.bConvalida = true;
            vm.bSelDipendente = true;
        }

        vm.righeC = [];
        vm.righeG = [];
        vm.CBlur = CBlur;
        vm.GBlur = GBlur;

        vm.dipendente = {};
        vm.dipendente.Profilo = [0, 0, 0, 0, 0, 0, 0];          //Questo viene modificato se ci sono festivi
        vm.profilo = [0, 0, 0, 0, 0, 0, 0];                     //Questo rimane inalterato e lo utilizzo per ripristinare vm.dipendente.Profilo
        vm.OreSpeseSezione = 0;
        vm.list.attivita = [];

        vm.totaliC = [0, 0, 0, 0, 0, 0, 0, 0];       //Ore ordinario (l'ultima colonna è il totale per riga)
        vm.totaliCS = [0, 0, 0, 0, 0, 0, 0, 0];      //Ore straordinario (l'ultima colonna è il totale per riga)
        vm.totaliV = [0, 0, 0, 0, 0, 0, 0, 0];      //Ore viaggio (l'ultima colonna è il totale per riga)
        vm.totaliTR = [0, 0, 0, 0, 0, 0, 0, 0];      //Ore trasferta (l'ultima colonna è il totale per riga)
        vm.totaliG = [0, 0, 0, 0, 0, 0, 0, 0];       //Ore giustificativi (l'ultima colonna è il totale per riga)
        vm.totali = [0, 0, 0, 0, 0, 0, 0, 0];        //Totali complessivi (l'ultima colonna è il totale per riga)  
        vm.causali = [{ Name: $translate.instant('O-Ordinario'), Id: 1 }, { Name: $translate.instant('V-OreDiViaggio'), Id: 2 }, { Name: $translate.instant('S-Straordinario'), Id: 3 }, { Name: $translate.instant('TR-Trasferta'), Id: 4 }, { Name: $translate.instant('SW-SmartWorking'), Id: 5 }];

        //Metodi su interfaccia
        vm.commessaChanged = commessaChanged;
        vm.sezioneChanged = sezioneChanged;
        vm.clearCommessa = clearCommessa;
        vm.attivitaChanged = attivitaChanged;

        vm.giustChanged = giustChanged;
        vm.getCommesse = getCommesse;
        vm.addRigaC = addRigaC;
        vm.delRigaC = delRigaC;
        vm.addRigaG = addRigaG;
        vm.delRigaG = delRigaG;
        vm.defaultRigaC = defaultRigaC;
        vm.next = next;
        vm.prev = prev;
        vm.selezionaDipendente = selezionaDipendente;
        vm.annullaDipendente = annullaDipendente;
        vm.getTimeSheet = getTimeSheet;
        vm.saveTimeSheet = saveTimeSheet;
        vm.deleteTimeSheet = deleteTimeSheet;
        vm.printTimeSheet = printTimeSheet;
        vm.convalidaTimeSheet = convalidaTimeSheet;


        // ---- ACTIVATE -------
        activate();

        function activate() {
            vm.loading = true;
            var promises = [getListGiustificativi(), getHolidays()];
            common.activateController(promises, controllerId).then(function () {
                datacontext.timeSheet_getDate().then(function (data) {
                    if (data)
                        vm.fAnno = new Date(data).getFullYear();

                    if ($routeParams.DipendenteId != null && $routeParams.Data != null) {
                        var d = $filter('date')($routeParams.Data, 'dd/MM/yyyy');
                        vm.fAnno = new Date($routeParams.Data).getFullYear();
                        datacontext.timeSheet_getWeekByDate(d).then(function (week) {
                            if (week) {
                                vm.fSettimana = week;
                                if (vm.fAnno == 2019 && (new Date(data).getDate() == 30 || new Date(data).getDate() == 31) && new Date(data).getMonth() + 1 == 12)
                                    vm.fAnno = 2020;
                            }
                            getDipendente($routeParams.DipendenteId).then(function () {
                                getTimeSheet();
                            });
                        });

                    } else {
                        datacontext.timeSheet_getWeek().then(function (week) {
                            if (week) {
                                vm.fSettimana = week;
                                vm.currentWeek = week;

                                if (vm.fAnno == 2019 && (new Date(data).getDate() == 30 || new Date(data).getDate() == 31) && new Date(data).getMonth() + 1 == 12)
                                    vm.fAnno = 2020;
                            }

                            getDipendente().then(function () {
                                getTimeSheet();
                            });
                        });
                    }
                });
            });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function getDipendente(id) {
            if ($rootScope.isAuthorized('USER') || !id)
                id = $rootScope.id ? $rootScope.id : 0;

            return datacontext.dipendente_get(id).then(function (data) {
                vm.dipendente = data;
                vm.dipendente.Profilo = [0, 0, 0, 0, 0, 0, 0];
                if (data.ProfiloOreId) {
					datacontext.profiloOre_get(data.ProfiloOreId).then(function (profilo) {
                        if (profilo) {
                            vm.dipendente.ProfiloOreDescrizione = profilo.Descrizione;
                            vm.dipendente.Profilo[0] = vm.profilo[0] = profilo.Ore1;
                            vm.dipendente.Profilo[1] = vm.profilo[1] = profilo.Ore2;
                            vm.dipendente.Profilo[2] = vm.profilo[2] = profilo.Ore3;
                            vm.dipendente.Profilo[3] = vm.profilo[3] = profilo.Ore4;
                            vm.dipendente.Profilo[4] = vm.profilo[4] = profilo.Ore5;
                            vm.dipendente.Profilo[5] = vm.profilo[5] = profilo.Ore6;
                            vm.dipendente.Profilo[6] = vm.profilo[6] = profilo.Ore7;
                        }
                    });
                }
            });
        }

        function getCommesse(index, ricerca) {
            return datacontext.commessa_getAllForTimeSheet(0, 0, ricerca, -1, -1, 'codice').then(function (data) {
                if (Array.isArray(data) && data.length > 0) {
                    return data;
                }
                return null;
            });
        }

        function commessaChanged(index, commessa) {            
            vm.righeC[index].attivita = [];
            vm.righeC[index].sezioni = [];
            vm.righeC[index].cod_att = 0;
            vm.righeC[index].cdc = 0;
            vm.righeC[index].commessa = commessa.Codice + ' - ' + commessa.Titolo;
			vm.righeC[index].commessa_id = commessa.Id;
			console.log('ddd');

            if (commessa.Id != undefined) {
				if (!$rootScope.bSezioni) {
					getListAttivita(index, commessa.Id, true).then(function(data) {
						vm.righeC[index].attivita = data;						
						if (data && data.length == 1)
							vm.righeC[index].cod_att = data[0].Id;
					});					
				}								
				else {
					getListSezioni(index, commessa.Id).then(function (data) {
						vm.righeC[index].sezioni = data;
						if (data && data.length == 1)
							vm.righeC[index].cdc = data[0].Id;
					});
				}                    
            }
        }

        function clearCommessa(index) {
            if (!vm.righeC[index].commessa) {
                vm.righeC[index].attivita = null;
                vm.righeC[index].cod_att = null;
                vm.righeC[index].cdc = null;

                for (var i = 0; i < 6; i++) {

                    if (vm.righeC[index].ore && vm.righeC[index].ore.length > 0) {
                        vm.righeC[index].ore[i].ore_lavoro = 0;
                        CBlur(i, index);
                    }
                }
            }
        }

        function sezioneChanged(index) {
            //vm.righeC[index].attivita = null;           //Elenco attività
            //vm.righeC[index].cod_att = null;            //Attività selezionata

            if (!vm.righeC[index].cdc) {
                for (var i = 0; i < 6; i++) {

                    if (vm.righeC[index].ore && vm.righeC[index].ore.length > 0) {
                        vm.righeC[index].ore[i].ore_lavoro = 0;
                        CBlur(i, index);
                    }
                }
            } else {
                //vm.righeC[index].attivita = getListAttivita(index, vm.righeC[index].cdc, true);
            }
        }

        function attivitaChanged(index, id) {
            if (!vm.righeC[index].cod_att) {
                for (var i = 0; i < 6; i++) {
                    if (vm.righeC[index].ore && vm.righeC[index].ore.length > 0) {
                        vm.righeC[index].ore[i].ore_lavoro = 0;
                        CBlur(i, index);
                    }
                }
            }
        }

        function giustChanged(index, id) {
            var g = _.find(vm.list.giustificativi, function (o) { return o.Id == id });

            if (!g) {
                for (var i = 0; i < 6; i++) {

                    if (vm.righeG[index].ore && vm.righeG[index].ore.length > 0) {
                        vm.righeG[index].ore[i].ore_lavoro = 0;
                        GBlur(i, index);
                    }
                }
            } else {
                vm.righeG[index].commessa = g.Name.substring(0, 3);
            }
        }

        function getListSezioni(index, commessaId) {
            return datacontext.sezione_getAllListForTimeSheet(commessaId).then(function (data) {
                if (Array.isArray(data) && data.length > 0)
                    return vm.righeC[index].sezioni = data;

                return null;
            });
        }

        function getListAttivita(index, commessaId, bAlert) {
            return datacontext.attivita_getAll(commessaId).then(function (data) {
                if (Array.isArray(data) && data.length > 0) {
                    if (vm.righeC[index])
                        return vm.righeC[index].attivita = data;
                }
                else {
                    if (bAlert)
                        logError($translate.instant('Nessuna attivita aperta per la commessa selezionata'));

                    return [];
                }
            });
        }

        function getListGiustificativi() {
            return datacontext.giustificativo_getAllList().then(function (data) {
                return vm.list.giustificativi = data;
            });
        }

        function getHolidays() {
            return vm.holidays = datacontext.festivita_getAll().then(function (data) {
                return vm.holidays = data;
            });
        }

        function addRigaC() {
            var riga = {
                'Id': 0,
                'commessa': '',
                'commessa_id': 0,
                'cod_att': 0,
                'cdc': 0,
                'ore': [],
                'Totale': 0,
                'attivita': [],
                'sezioni': [],
                'Giustificativo': 0,
                'causale': 1
            };

            if (!vm.date || vm.date.length == 0) {
                console.log('invalid dates');
                datacontext.timeSheet_getDatesOfWeek(vm.fAnno, vm.fSettimana).then(function (data) {
                    vm.date = data;

                    for (var i = 0; i <= 6; i++) {
                        var ora = {};
                        ora.n_giorno = i + 1;
                        ora.ore_lavoro = 0;
                        var data = new Date(vm.date[i]);
                        ora.giorno = data.getDate();
                        ora.mese = data.getMonth() + 1;
                        ora.anno = data.getFullYear();
                        riga.ore.push(ora);
                    }
                    vm.righeC.push(riga);
                });
            }
            else {
                for (var i = 0; i <= 6; i++) {
                    var ora = {};
                    ora.n_giorno = i + 1;
                    ora.ore_lavoro = 0;
                    var data = new Date(vm.date[i]);
                    ora.giorno = data.getDate();
                    ora.mese = data.getMonth() + 1;
                    ora.anno = data.getFullYear();
                    riga.ore.push(ora);
                }
                vm.righeC.push(riga);
            }
        }

        function delRigaC(index) {
            if (index == 0) {
                if (vm.righeC.length == 1) {
                    vm.righeC = [];
                    vm.list.attivita = [];
                    addRigaC();
                }
                else return;
            }
            else {
                vm.list.attivita = [];
                var obj = vm.righeC[index];
                vm.righeC.splice(index, 1);
            }

            vm.totaliC[7] = 0;
            vm.totaliCS[7] = 0;
            vm.totaliV[7] = 0;
            vm.totaliTR[7] = 0;

            for (var i = 0; i <= 6; i++) {
                vm.totaliC[i] = 0;
                vm.totaliCS[i] = 0;
                vm.totaliV[i] = 0;
                vm.totaliTR[i] = 0;

                vm.righeC.forEach(function (item) {
                    if (item.ore && item.ore.length > 0) {
                        if (item.causale == 1 || item.causale == 5) { //Ordinario e Smart working
                            vm.totaliC[i] += item.ore[i].ore_lavoro;
                            vm.totaliC[i] = parseFloat(vm.totaliC[i].toFixed(2));
                        }
                        else if (item.causale == 3) {         //Straordinario
                            vm.totaliCS[i] += item.ore[i].ore_lavoro;
                            vm.totaliCS[i] = parseFloat(vm.totaliCS[i].toFixed(2));
                        }
                        else if (item.causale == 2) {         //Viaggio
                            vm.totaliV[i] += item.ore[i].ore_lavoro;
                            vm.totaliV[i] = parseFloat(vm.totaliV[i].toFixed(2));
                        }
                        else if (item.causale == 4) {        //Trasferta
                            vm.totaliTR[i] += item.ore[i].ore_lavoro;
                            vm.totaliTR[i] = parseFloat(vm.totaliTR[i].toFixed(2));
                        }
                    }
                });


                vm.totaliC[7] += parseFloat(vm.totaliC[i].toFixed(2));
                vm.totaliCS[7] += parseFloat(vm.totaliCS[i].toFixed(2));
                vm.totaliV[7] += parseFloat(vm.totaliV[i].toFixed(2));
                vm.totaliTR[7] += parseFloat(vm.totaliTR[i].toFixed(2));

                vm.totali[i] = 0;
                vm.totali[i] = vm.totaliC[i] + vm.totaliCS[i] + vm.totaliG[i] + vm.totaliV[i] + vm.totaliTR[i];
                vm.totali[i] = parseFloat(vm.totali[i].toFixed(2));
                vm.totali[7] = vm.totaliC[7] + vm.totaliCS[7] + vm.totaliG[7] + vm.totaliV[7] + vm.totaliTR[7];
            }

            vm.totali[7] = vm.totaliC[7] + vm.totaliCS[7] + vm.totaliG[7] + vm.totaliV[7] + vm.totaliTR[7];
        }

        function addRigaG() {
            var riga = {
                'commessa': null,
                'ore': [],
                'Totale': 0,
                'Giustificativo': 1
            };

            if (!vm.date || vm.date.length == 0) {
                console.log('invalid dates');
                datacontext.timeSheet_getDatesOfWeek(vm.fAnno, vm.fSettimana).then(function (data) {
                    vm.date = data;
                    for (var i = 0; i <= 6; i++) {
                        var ora = {};
                        ora.n_giorno = i + 1;
                        ora.ore_lavoro = 0;
                        var data = new Date(vm.date[i]);

                        ora.giorno = data.getDate();
                        ora.mese = data.getMonth() + 1;
                        ora.anno = data.getFullYear();
                        riga.ore.push(ora);
                    }
                    vm.righeG.push(riga);
                });
            }
            else {
                for (var i = 0; i <= 6; i++) {
                    var ora = {};
                    ora.n_giorno = i + 1;
                    ora.ore_lavoro = 0;
                    var data = new Date(vm.date[i]);

                    ora.giorno = data.getDate();
                    ora.mese = data.getMonth() + 1;
                    ora.anno = data.getFullYear();
                    riga.ore.push(ora);
                }
                vm.righeG.push(riga);
            }
        }

        function delRigaG(index) {
            if (index == 0) {
                if (vm.righeG.length == 1) {
                    vm.righeG = [];
                    addRigaG();
                }
                else return;
            }
            else
                vm.righeG.splice(index, 1);

            for (var i = 0; i <= 6; i++) {
                vm.totaliG[i] = 0;
                vm.totaliG[7] = 0;
                vm.righeG.forEach(function (item) {
                    if (item.ore && item.ore.length > 0) {
                        vm.totaliG[i] += item.ore[i].ore_lavoro;
                        vm.totaliG[i] = parseFloat(vm.totaliG[i].toFixed(2));
                        vm.totaliG[7] += item.Totale;
                        vm.totaliG[7] = parseFloat(vm.totaliG[7].toFixed(2));
                    }
                });

                vm.totali[i] = 0;
                vm.totali[i] += vm.totaliC[i];
                vm.totali[i] += vm.totaliCS[i];
                vm.totali[i] += vm.totaliG[i];
                vm.totali[i] += vm.totaliV[i];
                vm.totali[i] += vm.totaliTR[i];
                vm.totali[7] = vm.totaliC[7] + vm.totaliCS[7] + vm.totaliG[7] + vm.totaliV[7] + vm.totaliTR[7];
            }
        }

        function CBlur(giorno, index) {
            vm.totaliC[giorno] = 0;
            vm.totaliCS[giorno] = 0;
            vm.totaliV[giorno] = 0;
            vm.totaliTR[giorno] = 0;
            vm.count = 0;
            vm.list.attivita = [];

            vm.righeC.forEach(function (item) {
                if (item.ore && item.ore.length > 0) {
                    if (item.causale == 1 || item.causale == 5) { //Ordinario e Smart working
                        vm.totaliC[giorno] += item.ore[giorno].ore_lavoro;
                        vm.totaliC[giorno] = parseFloat(vm.totaliC[giorno].toFixed(2));
                    }
                    else if (item.causale == 3) {         //Straordinario
                        vm.totaliCS[giorno] += item.ore[giorno].ore_lavoro;
                        vm.totaliCS[giorno] = parseFloat(vm.totaliCS[giorno].toFixed(2));
                    }
                    else if (item.causale == 2) {         //Viaggio
                        vm.totaliV[giorno] += item.ore[giorno].ore_lavoro;
                        vm.totaliV[giorno] = parseFloat(vm.totaliV[giorno].toFixed(2));
                    }
                    else if (item.causale == 4) {        //Trasferta
                        vm.totaliTR[giorno] += item.ore[giorno].ore_lavoro;
                        vm.totaliTR[giorno] = parseFloat(vm.totaliTR[giorno].toFixed(2));
                    }
                }

            });

            //Totali per righe            
            vm.righeC[index].Totale = 0;
            vm.righeC[index].ore.forEach(function (item) {
                if (item.ore_lavoro) {
                    vm.righeC[index].Totale += item.ore_lavoro;
                    vm.righeC[index].Totale = parseFloat(vm.righeC[index].Totale.toFixed(2));
                }
            });
            vm.totaliC[7] = 0;
            for (var i = 0; i <= 6; i++) {
                vm.totaliC[7] += vm.totaliC[i];
            };
            vm.totaliCS[7] = 0;
            for (var i = 0; i <= 6; i++) {
                vm.totaliCS[7] += vm.totaliCS[i];
            };
            //gestione viaggio
            vm.totaliV[7] = 0;
            for (var i = 0; i <= 6; i++) {
                vm.totaliV[7] += vm.totaliV[i];
            };
            //trasferta
            vm.totaliTR[7] = 0;
            for (var i = 0; i <= 6; i++) {
                vm.totaliTR[7] += vm.totaliTR[i];
            }

            vm.totaliC[7] = parseFloat(vm.totaliC[7].toFixed(2));
            vm.totaliCS[7] = parseFloat(vm.totaliCS[7].toFixed(2));
            vm.totaliV[7] = parseFloat(vm.totaliV[7].toFixed(2));
            vm.totaliTR[7] = parseFloat(vm.totaliTR[7].toFixed(2));

            AggiornaTotali(giorno);
        }

        function GBlur(giorno, index) {
            vm.totaliG[giorno] = 0;

            vm.righeG.forEach(function (item) {
                if (item.ore && item.ore.length > 0) {
                    var x = String(item.ore[giorno].ore_lavoro).replace(',', '.');
                    item.ore[giorno].ore_lavoro = parseFloat(x);
                    vm.totaliG[giorno] += parseFloat(x);
                    vm.totaliG[giorno] = parseFloat(vm.totaliG[giorno].toFixed(2));
                }
            });

            //Totali per righe
            vm.righeG[index].Totale = 0;
            if (vm.righeG[index].ore && vm.righeG[index].ore.length > 0) {
                vm.righeG[index].ore.forEach(function (item) {
                    if (item.ore_lavoro) {
                        vm.righeG[index].Totale += item.ore_lavoro;
                        vm.righeG[index].Totale = parseFloat(vm.righeG[index].Totale.toFixed(2));
                    }
                });
            }
            vm.totaliG[7] = 0;
            for (var i = 0; i <= 6; i++) {
                vm.totaliG[7] += vm.totaliG[i];
            };

            vm.totaliG[7] = parseFloat(vm.totaliG[7].toFixed(2));

            AggiornaTotali(giorno);
        }

        function AggiornaTotali(giorno) {
            vm.totali[giorno] = 0;
            vm.totali[giorno] += vm.totaliC[giorno];
            vm.totali[giorno] += vm.totaliCS[giorno];
            vm.totali[giorno] += vm.totaliG[giorno];
            vm.totali[giorno] += vm.totaliV[giorno]; //viaggio
            vm.totali[giorno] += vm.totaliTR[giorno]; //trasferta
            vm.totali[giorno] = parseFloat(vm.totali[giorno].toFixed(2));

            vm.totali[7] = vm.totaliC[7] + vm.totaliCS[7] + vm.totaliG[7] + vm.totaliV[7] + vm.totaliTR[7];
        }

        function defaultRigaC(index) {
            if (vm.dipendente.Profilo != null && vm.dipendente.Profilo.length > 0 && vm.righeC[index].commessa != null) {
				for (var i = 0; i < 7; i++) {
                    if (vm.righeC[index].ore && vm.righeC[index].ore.length > 0) {
                        vm.righeC[index].ore[i].ore_lavoro = parseFloat(String(vm.dipendente.Profilo[i]).replace(",", "."));
                        CBlur(i, index);
                    }
                }
            }
        }

        function getTimeSheet() {
            vm.loading = true;

            if (vm.fAnno < 0)
                vm.fAnno = new Date().getFullYear();

            if (vm.fAnno == 2020) {
                if (vm.fSettimana < 1 || vm.fSettimana > 53)
                    vm.fSettimana = 1;
            }
            else {
                if (vm.fSettimana < 1 || vm.fSettimana > 52)
                    vm.fSettimana = 1;
            }

            vm.fAnno = vm.fAnno;            //Cosa volevo fare qui?
            vm.date = [];
            vm.giorni = [];
            vm.colFestivo = [];
            vm.attivita = [];
            vm.dbTM = {};

            //Ripristino il profilo orario
            for (var i = 0; i <= 7; i++)
                vm.dipendente.Profilo[i] = vm.profilo[i];

            datacontext.timeSheet_getDatesOfWeek(vm.fAnno, vm.fSettimana).then(function (data) {
                vm.date = data;

                getRiepilogo(data[0], data[6]);

                for (var i = 0; i <= 6; i++) {
                    vm.giorni[i] = String(vm.date[i]);
                    vm.inizio = String(vm.date[0]);
                    vm.fine = String(vm.date[6]);

                    //Verifica festivi
                    vm.colFestivo[i] = false;

                    var data = new Date(vm.date[i]);
                    var giorno = data.getDate();
                    var mese = data.getMonth() + 1;
                    var anno = data.getFullYear();
                    var check = null;
                    check = _.find(vm.holidays, function (o) {
                        return (o.giorno == giorno && o.mese == mese && (o.anno == 0 || o.anno == anno))
                    });

                    if (check != null) {
                        vm.colFestivo[i] = true;
                        vm.colTitle[i] = check.descrizione;
                        if (vm.dipendente.Profilo)
                            vm.dipendente.Profilo[i] = "0,00";
                    }
                    else {
                        vm.colFestivo[i] = false;
                        vm.colTitle[i] = '';
                    }
                }
            });

            vm.totaliC = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totaliCS = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totaliV = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totaliTR = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totaliG = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totali = [0, 0, 0, 0, 0, 0, 0, 0];

            var status_sync = 0;

			return datacontext.timeSheet_get(vm.dipendente.Id, vm.fAnno, vm.fSettimana).then(function (data) {				
                if (data && data.Id) {
                    angular.copy(data, vm.dbTM);

                    var ordinario = _.filter(data.righe, { 'giustificativo': 0 });
                    var straordinario = _.filter(data.righe, { 'giustificativo': 1 });

                    if (ordinario && ordinario.length > 0) {
                        vm.righeC = ordinario;
                        for (var i = 0; i < vm.righeC.length; i++) {
                            if (vm.righeC[i].ore) {
                                vm.righeC[i].ore = _.sortBy(vm.righeC[i].ore, 'n_giorno');
                            }

                            if (!$rootScope.bSezioni) {
                                if (vm.righeC[i].commessa != null && vm.righeC[i].commessa != undefined) 
                                    vm.righeC[i].attivita = getListAttivita(i, vm.righeC[i].commessa_id, false);                                                                     
                            } else {
                                if (vm.righeC[i].commessa != null && vm.righeC[i].commessa != undefined) 
                                    vm.righeC[i].sezioni = getListSezioni(i, vm.righeC[i].commessa_id);                                                                     
                            }

                            for (var j = 0; j <= 6; j++) {
                                CBlur(j, i);
                                if (vm.righeC[i].ore[j] && vm.righeC[i].ore.length > 0) {
                                    //Verifica sincronizzazione
                                    if (vm.righeC[i].ore[j].status_sync == 1 || vm.righeC[i].ore[j].status_sync == -1) {
                                        vm.righeC[i].validato = 1;
                                        status_sync = 1;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        vm.righeC = [];
                        addRigaC();
                    }

                    if (straordinario && straordinario.length > 0) {
                        vm.righeG = straordinario;
                        for (var i = 0; i < vm.righeG.length; i++) {
                            if (vm.righeG[i].ore) {
                                vm.righeG[i].ore = _.sortBy(vm.righeG[i].ore, 'n_giorno');
                            }

                            for (var j = 0; j <= 6; j++) {
                                GBlur(j, i);
                            }
                        }
                    }
                    else {
                        vm.righeG = [];
                        addRigaG();
                    }
                }
                else
                    azzeraTimeSheet();

                vm.loading = false;
                vm.timeSheet = data;
                vm.timeSheet.tipo_ore = vm.dipendente.ProfiloOreId;
                vm.timeSheet.status_sync = status_sync;

                return vm.timeSheet;
            });
        }

        function getRiepilogo(dtInizio, dtFine) {
            return datacontext.timeSheet_getRiepilogoSettimanale(vm.dipendente.Id, dtInizio, dtFine).then(function (data) {
                if (data && data.length > 0)
                    vm.opConvalida = data[0].OpConvalida;
            });
        }

        function next() {
            vm.timeSheetPrevious = angular.copy(vm.timeSheet);

            var x = vm.fSettimana + 1;
            if (vm.fAnno == 2020) {
                if (x > 53) {
                    vm.fSettimana = 1;
                    vm.fAnno++;
                }
                else
                    vm.fSettimana++;
            }
            else {
                if (x > 52) {
                    vm.fSettimana = 1;
                    vm.fAnno++;
                }
                else
                    vm.fSettimana++;
            }

            getTimeSheet().then(function (data) {
                if (vm.timeSheet.Id == 0 && vm.timeSheetPrevious.Id > 0) {
                    var title = 'Importazione dati';
                    var msg = 'Vuoi importare le commesse dalla settimana precedente?';
                    bDialog.confirmationDialog(title, msg, 'OK', $translate.instant('Annulla')).then(function () { //YES
                        var ordinario = _.filter(vm.timeSheetPrevious.righe, { 'giustificativo': 0 });
                        if (ordinario && ordinario.length > 0) {
                            for (var i = 0; i < ordinario.length; i++) {
                                if (ordinario.length > vm.righeC.length)
                                    addRigaC();

                                vm.righeC[i].commessa = ordinario[i].commessa;
                                vm.righeC[i].commessa_id = ordinario[i].commessa_id;
                                vm.righeC[i].causale = ordinario[i].causale;

                                if (!$rootScope.bSezioni) {
                                    vm.righeC[i].cod_att = ordinario[i].cod_att;
                                    vm.righeC[i].attivita = ordinario[i].attivita;
                                }
                                else {
                                    vm.righeC[i].cdc = ordinario[i].cdc;
                                    vm.righeC[i].sezioni = ordinario[i].sezioni;
                                }
                            }
                        }
                    }, function (btn) { // NO
                    });
                }
            });

        }

        function prev() {
            var x = vm.fSettimana - 1;
            if (vm.fAnno == 2021) {
                if (x <= 0) {
                    vm.fSettimana = 53;
                    vm.fAnno--;
                }
                else
                    vm.fSettimana--;
            }
            else {
                if (x <= 0) {
                    vm.fSettimana = 52;
                    vm.fAnno--;
                }
                else
                    vm.fSettimana--;
            }

            getTimeSheet();
        }

        function azzeraTimeSheet() {
            vm.timeSheet = {};
            vm.timeSheet.Id = 0;
            vm.timeSheet.id_dipendente = vm.dipendente.Id;
            vm.timeSheet.tipo_ore = vm.dipendente.ProfiloOreId;
            vm.timeSheet.anno = vm.fAnno;
            vm.timeSheet.settimana = vm.fSettimana;

            vm.righeC = [];
            vm.righeG = [];
            vm.dbTM = [];
            vm.totaliC = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totaliCS = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totaliV = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totaliTR = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totaliG = [0, 0, 0, 0, 0, 0, 0, 0];
            vm.totali = [0, 0, 0, 0, 0, 0, 0, 0];
            addRigaC();
            addRigaG();
        }

        vm.filterKeydown = function (event, vm) {
            if (event.keyCode == 13) getTimeSheet();
        }

        // Selezione dipendente
        function selezionaDipendente() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/dipendenteSelect.html?version=30',
                controller: 'dipendenteSelect',
                windowClass: 'modal-wide',
                resolve: {}
            });

            modalInstance.result.then(function (returnItem) {
                getDipendente(returnItem.id).then(function () {
                    getTimeSheet();
                });
            });
        }

        function annullaDipendente() {
            getDipendente($rootScope.Id).then(function () {
                getTimeSheet();
            });
        }

        function saveTimeSheet() {
            if (vm.loading)
                return;

            vm.break = false;
            vm.breakGiust = false;
            vm.checkDuplicato = false;
            vm.rigaVuota = false;

            vm.loading = true;

            vm.righeC.forEach(function (riga) {
                if (!$rootScope.bSezioni) {
                    if (!riga.commessa_id || !riga.cod_att) {
                        // riga registrazione ordinaria vuota
                        if (!riga.commessa_id && !riga.cod_att)
                            vm.rigaVuota = true;
                        else
                            vm.break = true;
                    }
                } else {
                    if (!riga.commessa_id || !riga.cdc) {
                        // riga registrazione ordinaria vuota
                        if (!riga.commessa_id && !riga.cdc)
                            vm.rigaVuota = true;
                        else
                            vm.break = true;
                    }
                }
            });


            vm.righeG.forEach(function (riga) {
                if (!riga.commessa_id)
                    vm.breakGiust = true;
            });

            if ((vm.rigaVuota && vm.breakGiust) || vm.break) {
                if (!$rootScope.bSezioni)
                    logError($translate.instant('IndicareCommessaEAttivita'));
                else
                    logError($translate.instant('IndicareCommessaESezione'));
                vm.loading = false;
                return;
            }

            var duplicatiOrdinario = _.map(vm.righeC, function (o, i) {
                if (!$rootScope.bSezioni) {
                    var obj = {
                        commessa_id: o.commessa_id,
                        cod_att: o.cod_att,
                        causale: o.causale
                    };

                    var eq = _.find(vm.righeC, function (e, ind) {
                        var obj2 = {
                            commessa_id: e.commessa_id,
                            cod_att: e.cod_att,
                            causale: e.causale
                        };
                        if (i > ind) {
                            return _.isEqual(obj2, obj);
                        }
                    });
                } else {
                    var obj = {
                        commessa_id: o.commessa_id,
                        cdc: o.cdc,
                        causale: o.causale
                    };

                    var eq = _.find(vm.righeC, function (e, ind) {
                        var obj2 = {
                            commessa_id: e.commessa_id,
                            cdc: e.cdc,
                            causale: e.causale
                        };
                        if (i > ind) {
                            return _.isEqual(obj2, obj);
                        }
                    });
                }


                if (eq) {
                    vm.checkDuplicato = true;
                }
                return obj;
            });

            /*var duplicatiGiust = _.map(vm.righeG, function (o, i) {
                var obj = {
                    commessa_id: o.commessa_id
                };

                var eq = _.find(vm.righeG, function (e, ind) {
                    var obj2 = {
                        commessa_id: e.commessa_id
                    };
                    if (i > ind) {
                        return _.isEqual(obj2, obj);
                    }
                });

                if (eq) {
                    vm.checkDuplicato = true;
                }
                return obj;
            });*/

            if (vm.checkDuplicato) {
                logError($translate.instant('Impossibile salvare: sono presenti righe duplicate'));
                vm.loading = false;
                return;
            }


            //Concatenazione righe
            vm.timeSheet.righe = vm.righeC.concat(vm.righeG);
			return datacontext.timeSheet_save(vm.timeSheet).then(function (data) {
				console.dir(data);
                if (data && data.Id && data.Id > 0) {
                    vm.timeSheet = data;
                    angular.copy(data, vm.dbTM);
                    var ordinario = _.filter(vm.timeSheet.righe, { 'giustificativo': 0 });
                    var straordinario = _.filter(data.righe, { 'giustificativo': 1 });

                    if (ordinario && ordinario.length > 0) {
                        vm.righeC = ordinario;
                        for (var i = 0; i < vm.righeC.length; i++) {
                            if (!$rootScope.bSezioni) {
                                if (vm.righeC[i].commessa != null && vm.righeC[i].commessa != undefined)
                                    vm.righeC[i].attivita = getListAttivita(i, vm.righeC[i].commessa_id, false);
                            } else {
                                if (vm.righeC[i].commessa != null && vm.righeC[i].commessa != undefined)
                                    vm.righeC[i].sezioni = getListSezioni(i, vm.righeC[i].commessa_id);
                            }

                            for (var j = 0; j <= 6; j++) {
                                CBlur(j, i);

                                //Verifica sincronizzazione
                                if (vm.righeC[i].ore[j].status_sync == 1 || vm.righeC[i].ore[j].status_sync == -1) {
                                    vm.righeC[i].validato = 1;
                                    vm.timeSheet.status_sync = 1;
                                }
                            }
                        }
                    }

                    if (straordinario && straordinario.length > 0) {
                        vm.righeG = straordinario;
                        for (var i = 0; i < vm.righeG.length; i++) {
                            for (var j = 0; j <= 6; j++) {
                                GBlur(j, i);
                            }
                        }
                    }

                    logSuccess($translate.instant('Dati salvati con successo'));
                }
                else
                    logError($translate.instant('Errore durante il salvataggio dei dati'));

                vm.loading = false;
            });
        }

        function convalidaTimeSheet() {
            datacontext.validazioneTimeSheet_convalida(vm.timeSheet.Id, !vm.timeSheet.status).then(function (data) {
                if (!data) {
                    logSuccess($translate.instant('Dati salvati'));
                    getTimeSheet();
                }
                else {
                    logError($translate.instant('Errore durante il salvataggio dei dati'));
                }
            });
        }

        function deleteTimeSheet() {
            if (vm.timeSheet.status_sync == 1)
                return;

            var msg = $translate.instant('il') + ' Timesheet';
            bDialog.deleteDialog(msg).then(function () {
                vm.loading = true;
                return datacontext.timeSheet_delete(vm.timeSheet.Id).then(function (data) {
                    if (data == '200') {
                        azzeraTimeSheet();
                        logSuccess($translate.instant('Dati eliminati con successo'));
                    }
                    else {
                        logError($translate.instant('Errore durante la cancellazione dei dati'));
                    }
                    vm.loading = false;
                });
            });
        }

        function printTimeSheet(bPDF) {
            if (vm.loading == true)
                return;

            vm.loading = true;
            datacontext.report_getTimeSheet(bPDF, vm.dipendente.Id, vm.fAnno, vm.fSettimana).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    document.body.appendChild(a);
                    a.href = data.url;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }

    }
})();
